var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-img default-thumbnail",style:({ 'background-color': _vm.placeholderColor }),attrs:{"data-qa":"default thumbnail"}},[_c('span',{class:_vm.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }